import React from 'react';
import './About.css';

function About() {
  return (
    <div className="about">
      <div className="container">
        <div className="section-header">
          <span className="section-tag">About Us</span>
          <h2 className="section-title">Creating commercial impact through hospitality</h2>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p>
              We approach hospitality as a strategic driver of brand equity, relationships and long-term value. From global sporting events to private engagements, our work sits at the intersection of strategy and execution.
            </p>
            <p>
              Our expertise spans two interconnected practices: advising brands and rights-holders on commercial hospitality strategy, and providing private office services to individuals and families.
            </p>
            <p>
              From concept to delivery, we combine strategic insight with creative precision to shape experiences that matter. Our team brings international hospitality training and first-hand experience across global sporting events, government entities, brand activations and private client services.
            </p>
            <p>
              Whether advising brands, rights-holders or private families, our focus is consistent: creating hospitality that builds relationships, amplifies value and leaves a legacy.
            </p>
          </div>
          
          <div className="about-image-gallery">
            <div className="gallery-grid">
              <div className="gallery-item">
                <img src="/img/img-gallery1.webp" alt="Gallery" />
              </div>
              <div className="gallery-item">
                <img src="/img/img-galler6.webp" alt="Gallery" />
              </div>
              <div className="gallery-item">
                <img src="/img/img-gallery3.webp" alt="Gallery" />
              </div>
              <div className="gallery-item">
                <img src="/img/img-gallery5.webp" alt="Gallery" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
